import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Input,
  Alert,
} from 'reactstrap';
import OBIAutocomplete from '../../OBIAutocomplete';
import del from '../../../Res/Icon/delete.png';
import plus from '../../../Res/Icon/plus.png';
import './configModal.css';
import { sendBulkActionsToApi, changeBulkBoxSession } from '../../../actions/BoxSessionLogging';

function ConfigModal({
  showBoxConfigModal,
  downloadConfig,
  hideBoxConfig,
  confSelectedObi,
  download,
  obis,
  setConfSelectedObi,
  setJsonConfig,
}) {
  const dispatch = useDispatch();
  const obiName = '';
  const defaultJson = [{ objKey: '', objValue: '' }];
  const [alert, setAlert] = useState(false);
  const [inputList, setInputList] = useState(defaultJson);
  useEffect(() => {
    if (showBoxConfigModal) {
      setInputList(defaultJson);
      setAlert(false);
    }
  }, [showBoxConfigModal]);

  const checkIfAnyFieldIsEmpity = () => {
    for (let i = 0; i < inputList.length; i += 1) {
      if (inputList[i].objKey.length === 0 || inputList[i].objValue.length === 0) {
        return false;
      }
    }
    return true;
  };

  const addNewKeyValuePair = () => {
    if (checkIfAnyFieldIsEmpity()) {
      setAlert(false);
      //[BulkAction] - Change
      dispatch(changeBulkBoxSession('Added Configurations For Advanceed EPI ', 'epiKeyValue'));
      setInputList([...inputList, { objKey: '', objValue: '' }]);
    } else {
      setAlert(true);
    }
  };

  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleInputChange = (event, index, prevData) => {
    const { name, value } = event.target;
    if (name === 'objKey') {
      //[BulkAction] - Change
      dispatch(changeBulkBoxSession(`Objkey chnaged from ${prevData} to ${value} `, 'objKey'));
    }
    if (name === 'objValue') {
      //[BulkAction] - Change
      dispatch(changeBulkBoxSession(`Objvalue changed from ${prevData} to ${value} `, 'objValue'));
    }
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const shapeObject = () => {
    const list = [...inputList];
    const newArr = list.map(({ objKey, objValue }) => {
      return { [objKey]: objValue };
    });
    return JSON.stringify(newArr);
  };

  return (
    <Modal isOpen={showBoxConfigModal}>
      <ModalHeader>Advanced EPI Configuration</ModalHeader>
      <ModalBody>
        <div className="container">
          <FormGroup row>
            <Label for="epi" sm={6}>
              Select EPI:
            </Label>
            <Row>
              <Col sm={6}>
                <OBIAutocomplete
                  placeholder="Choose one"
                  obis={obis || []}
                  searchTerm={obiName || ''}
                  onChange={({ suggestion }) => {
                    setConfSelectedObi(suggestion);
                    //[BulkAction] - Change
                    dispatch(
                      changeBulkBoxSession(
                        'EPI Selected For Advanced EPI Configuration',
                        'epiSelection',
                      ),
                    );
                  }}
                />
              </Col>
              <Col sm={6}>
                <Button
                  className="download-config-btn"
                  disabled={confSelectedObi === null}
                  onClick={downloadConfig}
                >
                  <img
                    className="actions-icon"
                    src={download}
                    style={{ height: '20px', margin: '-4px 4px 0px 0px' }}
                    alt="..."
                  />
                  Download Configuration:
                </Button>
              </Col>
            </Row>
          </FormGroup>
          {alert && <Alert color="danger">Fill all fields</Alert>}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Label style={{ marginBottom: 0 }} for="config">
                Add Configuration:
              </Label>
            </div>
            <div>
              <img
                className="actions-icon config-add-icon"
                src={plus}
                onClick={addNewKeyValuePair}
                alt="plus icon"
              />
            </div>
          </div>
          <div className="config-scrollable">
            {inputList.length > 0 &&
              inputList.map((obj, index) => (
                <Row className="margin-y12" key={index}>
                  <Col sm="5">
                    <Input
                      type="text"
                      name="objKey"
                      value={obj.objKey}
                      onChange={e => handleInputChange(e, index, obj.objKey)}
                      placeholder={`sampleKey${index + 1}`}
                      spellCheck={false}
                      autoComplete={false}
                    />
                  </Col>
                  <Col sm="5">
                    <Input
                      type="text"
                      name="objValue"
                      value={obj.objValue}
                      onChange={e => handleInputChange(e, index, obj.objValue)}
                      placeholder={`sampleValue${index + 1}`}
                      spellcheck="false"
                      autocomplete="false"
                    />
                  </Col>
                  <Col sm="2">
                    {inputList.length !== 1 && (
                      <img
                        className="actions-icon"
                        src={del}
                        onClick={() => handleRemoveClick(index)}
                        alt="delete icon"
                      />
                    )}
                  </Col>
                </Row>
              ))}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            hideBoxConfig();
            setInputList(defaultJson);
          }}
        >
          Close
        </Button>
        <Button
          color="primary"
          onClick={() => {
            if (checkIfAnyFieldIsEmpity()) {
              setJsonConfig(`{"settings": ${shapeObject()}}`);
              //[BulkAction] - Call Api
              dispatch(sendBulkActionsToApi());
            } else {
              setAlert(true);
            }
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfigModal;
